export default __webpack_public_path__ + "static/media/am.d807f74b.svg";